export function basicAuthEncoder(user) {
  return `Basic ${btoa(`${user.username}:${user.password}`)}`;
}



/** WEBPACK FOOTER **
 ** ./src/services/authentication/basicAuthEncoder.js
 **/